import React, { useState } from 'react';
import { Alert } from '@biome-design-system/ui/Alert';
import { Log } from 'Src/types';

interface EmergencyDisclaimerSimpleProps {
  bannerConfig: {
    text?: string;
    enabled?: boolean;
  };
  closeButtonAriaLabel: string;
  log: Log;
}
export const EmergencyDisclaimerSimple = ({
  bannerConfig,
  log,
  closeButtonAriaLabel
}: EmergencyDisclaimerSimpleProps) => {
  const [isOpen, setIsOpen] = useState(true);
  if (!isOpen) {
    return null;
  }
  const handleClose = () => {
    log('user_action.search_results.emergency_warning.close_warning');
    setIsOpen(false);
  };

  return (
    <Alert
      severity="error"
      variant="outlined"
      onClose={handleClose}
      closeText={closeButtonAriaLabel}
    >
      {bannerConfig.text || ''}
    </Alert>
  );
};
